import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";
import {getMessages} from "../../../../tppServices/translations/messages";
import {setGenericEvent} from "../../../../store/actions/dataLayer";

const FooterCopyright = (props) => {
    const { context } = props;
    const messages = getMessages();
    const intl = useIntl();
    const { formatMessage: t } = intl;

    const dispatch = useDispatch();
    const trackGenericClick = (event) => () => {
        if (event) {
            dispatch(setGenericEvent('navigation - footer', event.action, event.label));
        }
    };

    return (
        <div className="copyright-info">
            <FormattedMessage
                values={{ date: new Date().getFullYear() }}
                {...messages.footer.copyright}
            />
            {t(messages.footer.boatsGroup).trim().length > 0 && (
                <a
                    href={context.url}
                    title={t(messages.footer.boatsGroup)}
                    onClick={trackGenericClick(context.event)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t(messages.footer.boatsGroup)}
                </a>
            )}
            {t(messages.footer.allRightsReserved).trim().length > 0 &&
                ` - ${t(messages.footer.allRightsReserved)}`}
            {t(messages.footer.endorsedBranding).trim().length > 0 &&
                ` | ${t(messages.footer.endorsedBranding)}`}
        </div>
    );
};

FooterCopyright.propTypes = {
    context: PropTypes.object
};

export default FooterCopyright;
